import React, { useRef, useState, useEffect } from "react";
import Turnstile from "react-turnstile";

const PayByMobileCaptchaWrapper = ({ captchaKey, payByMobile }) => {

    const [shouldRenderCaptcha, setShouldRenderCaptcha] = useState(true);
    const previousKeyRef = useRef(null);

    useEffect(() => {
        if (previousKeyRef.current !== captchaKey) {
            setShouldRenderCaptcha(true);
            previousKeyRef.current = captchaKey;
        }
    }, [captchaKey]);

    return (
        <>
            {shouldRenderCaptcha && (
                <Turnstile
                    key={captchaKey}
                    sitekey={app.config.SITE_KEY}
                    onSuccess={(token) => {
                        payByMobile({ captchaToken: token });
                        setShouldRenderCaptcha(false)
                    }}
                    onError={() => {
                        payByMobile({ captchaToken: '' });
                        setShouldRenderCaptcha(false)
                    }}
                />
            )}
        </>
    );
};

export default PayByMobileCaptchaWrapper;